import RegisterAndSignInController from "./RegisterAndSignInController";

const RegisterAndSignInModalController = function (modalInstance, container, onSucessCallback, showRegister) {
    new RegisterAndSignInController(container, onSucessCallback, showRegister);
}
export default RegisterAndSignInModalController;